import RTMPPushChannelsController from './rtmp-push-channels';
import SettingsAppearanceController from './appearance';
import WifiConfigurationService from './wifi-configuration-service';
import registerComponents from './components';

// The `wire` helper only deals with simple states. We need to add the
// detail sub-states as well, so we'll just do it by hand here.
let module = angular.module('settings', []);

module.service('WifiConfigurationService', WifiConfigurationService);

registerComponents(module);

module.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state('settings', {
      url: '/settings',
      template: require('./settings.html'),
      abstract: true,
      controllerAs: 'vm',
    })
    .state('settings.appearance', {
      url: '/appearance',
      template: require('./appearance.html'),
      controller: SettingsAppearanceController,
      controllerAs: 'vm',
    })
    .state('settings.integrations', {
      url: '/integrations?integration_id',
      template: require('./integrations.html'),
      controller: require('./integrations.js').default,
      controllerAs: 'vm',
    })
    .state('settings.facebook', {
      url: '/facebook',
      template: require('./facebook.html'),
      controller: require('./facebook.js').default,
      controllerAs: 'vm',
    })
    .state('settings.youtube', {
      url: '/youtube?code&error&link',
      template: require('./youtube.html'),
      controller: require('./youtube.js').default,
      controllerAs: 'vm',
    })
    .state('settings.vimeo', {
      url: '/vimeo?code&link',
      template: require('./vimeo.html'),
      controller: require('./vimeo.js').default,
      controllerAs: 'vm',
    })
    .state('settings.payment', {
      url: '/payment?pd_did&pd_sid&show_orders&action',
      template: require('./payment.html'),
      controller: require('./payment.js').default,
      controllerAs: 'vm',
    })

    .state('settings.twitter', {
      url: '/twitter?link',
      template: require('./twitter.html'),
      controller: require('./twitter.js').default,
      controllerAs: 'vm',
    })
    .state('settings.rtmp_destinations', {
      url: '/rtmp-push-channels',
      template: require('./rtmp-push-channels.html'),
      controller: RTMPPushChannelsController,
      controllerAs: 'vm',
    })
    .state('settings.upgrade', {
      url: '/upgrade?pd_did&pd_sid',
      // The upgrade page is deprecated, but there still may be links our there to it
      // Redirect to the payment page
      controller: function ($state) {
        'ngInject';

        $state.go('settings.payment', $state.params);
      },
    })

    // Migrated pages to dashboard_vue
    .state('settings.overview', {
      url: '/',
      template: ``,
      controller: () =>
        window.location.replace(`${window.VUE_DASHBOARD_ROOT}/settings/preferences`),
    })
    .state('settings.my_account', {
      url: '/my-account?password_changed',
      template: ``,
      controller: () => window.location.replace(`${window.VUE_DASHBOARD_ROOT}/settings/my-account`),
    })
    .state('settings.users', {
      url: '/users',
      template: ``,
      controller: () => window.location.replace(`${window.VUE_DASHBOARD_ROOT}/settings/users`),
    })
    .state('settings.storage', {
      url: '/storage',
      template: '',
      controller: () => window.location.replace(`${window.VUE_DASHBOARD_ROOT}/settings/storage`),
    })
    .state('settings.api_keys', {
      url: '/api-keys',
      template: ``,
      controller: () => window.location.replace(`${window.VUE_DASHBOARD_ROOT}/settings/api-keys`),
    });
});

export default module;



// WEBPACK FOOTER //
// ./app/pages/settings/_index.js